import { UseQueryResult, useQuery } from 'react-query';

import { useAuth } from 'src/hooks';

import { getScheduledCallDetails } from 'src/utils/urls';

import { ScheduleCall } from '../types/scheduleCallType';

async function fetchScheduledCallDetails({
  token,
  tokenType,
  submissionId,
}: Tvariable): Promise<ScheduleCall> {
  const response = await fetch(getScheduledCallDetails(submissionId), {
    method: 'GET',
    headers: { Authorization: `${tokenType} ${token}` },
  });
  return response.json();
}
type Tvariable = {
  token: string;
  tokenType: string;
  submissionId: number | undefined;
};
type TError = { message: string };

function useGetScheduledCallDetails(
  submissionId: number | undefined,
): UseQueryResult<ScheduleCall, TError> {
  const { token, tokenType } = useAuth();
  return useQuery(
    ['get_scheduledCall_details', submissionId],
    async () => {
      const result = await fetchScheduledCallDetails({
        token,
        tokenType,
        submissionId,
      });
      return result;
    },
    {
      staleTime: 60 * 1000,
      enabled: submissionId !== undefined,
    },
  );
}

export { useGetScheduledCallDetails };
